import { NotFound } from 'component/errors/not-found';

export default function ScreenNotFound() {
    return <NotFound />;
}
